import React, { useEffect, useRef, useState } from "react";
import { Globe, Check } from "lucide-react";
import { setLanguage, getLanguage } from "@/lib/i18n";

const LANGS = [
  ["sq", "🇦🇱", "Shqip"], ["en", "🇬🇧", "English"], ["sv", "🇸🇪", "Svenska"], ["da", "🇩🇰", "Dansk"],
  ["no", "🇳🇴", "Norsk"], ["de", "🇩🇪", "Deutsch"], ["fr", "🇫🇷", "Français"], ["it", "🇮🇹", "Italiano"],
];

export function LanguageMenu() {
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState(getLanguage());
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    document.addEventListener("pointerdown", close);
    return () => document.removeEventListener("pointerdown", close);
  }, [open]);
  const pick = (k) => { setLanguage(k); setCur(k); setOpen(false); };
  return (
    <div ref={ref} className="relative" translate="no">
      <button data-testid="language-button" onClick={() => setOpen(!open)} aria-label="Gjuha" className="p-2 rounded-full hover:bg-slate-100 transition-colors">
        <Globe className="w-5 h-5 text-emerald-500" />
      </button>
      {open && (
        <div data-testid="language-menu" className="absolute right-0 top-11 z-50 w-44 bg-white rounded-2xl shadow-xl border border-slate-100 p-1.5">
          {LANGS.map(([k, f, n]) => (
            <button key={k} data-testid={`language-option-${k}`} onClick={() => pick(k)}
              className={`w-full flex items-center gap-2.5 px-2.5 py-2 rounded-xl text-sm ${cur === k ? "bg-emerald-50 text-emerald-700 font-semibold" : "text-slate-700 hover:bg-slate-50"}`}>
              <span className="text-lg leading-none">{f}</span><span className="flex-1 text-left">{n}</span>
              {cur === k && <Check className="w-4 h-4 text-emerald-500" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default LanguageMenu;
